import { NumberFormat } from '@billy/design-system'

import { LocaleIdentifier } from '../../../../../types/localeIdentifier'
import { VatRateItemValue } from '../types/vatRateItemValue'

interface GetDisplayedVatRateOptions {
  locale: LocaleIdentifier
  vatRate: Partial<VatRateItemValue>
}

export const getDisplayedVatRate = ({ locale, vatRate }: GetDisplayedVatRateOptions): string => {
  return NumberFormat.getPercentNumber(vatRate.rate, locale)
}
